import styled from 'styled-components';
import { useEffect, useState } from 'react';
import { formatDate } from '../../../../func/func';
import { RowTable } from '../../../../func/components/Table';
import ListContent, { ListData } from '../ListContent';
/**총괄표제부 */

const SummaryBuildingInfo = ({ data }: any) => {
  const MakeSelectedNo2 = (data: any) => {
    // 카운터 초기화
    let mainCount = 1;
    let subCount = 1;
    return data.map((item: any, index: number) => {
      if (item.mainminorcodename === '주건축물') {
        return {
          name: `주${mainCount++}`,
          use: item.mainpurposecodename,
          no: index,
        }; // 주용도 카운트 증가
      } else {
        return {
          name: `부${subCount++}`,
          use: item.mainpurposecodename,
          no: index,
        }; // 부용도 카운트 증가
      }
    });
  };

  const [selectedNo, setSelectedNo] = useState<string>(
    MakeSelectedNo2(data)[0],
  ); // 첫 번째 'no' 기본값
  const [selectedValue, setSelectedValue] = useState<any>();

  // 'no' 값 변경 시 처리
  const handleNoChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedNo = event.target.value;
    setSelectedNo(selectedNo);
    setSelectedValue(data[selectedNo]);
  };

  const subHouseInfoMapping = {
    ledgercodename: '구분',
    buildingname: '건물명',
    mainpurposecodename: '주용도',
    otheruses: '기타용도',
    totalfloorareawobase: '용적률산정연면적',
    approvalDate: '허가일',
    selectedValue: '주 건축물',
    annexenum: '부속 건축물',
    createddate: '착공일',
    numofhouseholds: '총 호수/가구수/세대수',
    etc: '외 필지수',
    approvaldate: '사용승인일',
    warning: '위반내용',
  };

  useEffect(() => {
    // data가 변경될 때마다 첫 번째 'no' 값으로 설정
    setSelectedNo(data[0].no);
    setSelectedValue(data[0]);
  }, [data]);

  const transformData = (data: Record<string, any>): ListData[] => {
    return Object.entries(subHouseInfoMapping).map(([key, label]) => {
      let value = data[key] ?? '-';

      switch (label) {
        case '주 건축물':
          value = `${selectedValue.g || '-'}`;
          break;
        case '부속 건축물':
          value = `${
            selectedValue.annexenum === 0
              ? '없음'
              : selectedValue.annexenum || '-'
          }`;
          break;
        case '용적률산정연면적':
          value = `${selectedValue.totalfloorareawobase}평`;
          break;
        case '착공일':
          value = `${formatDate(selectedValue.createddate)}`;
          break;
        case '총 호수/가구수/세대수':
          value = `${
            selectedValue.numofhouseholds === 0
              ? '없음'
              : selectedValue.numofhouseholds || '-'
          }`;
          break;
        case '사용승인일':
          value = `${formatDate(selectedValue.approvaldate)}`;
          break;
      }

      return { label, value };
    });
  };

  return (
    <DetailWrap>
      <DetailBox>
        <TitleBox>
          <Title>
            <img src="/assets/images/icon/statistics.svg" alt="" />
            {data.length > 1 ? '총괄표제부' : '표제부'}
          </Title>
          <SelectBoxWrapper value={selectedNo} onChange={handleNoChange}>
            {MakeSelectedNo2(data).map((item: any, index: number) => (
              <option key={item.no} value={item.no}>
                {item.name}&nbsp;&nbsp;
                {item.use}
              </option>
            ))}
          </SelectBoxWrapper>
        </TitleBox>
        {selectedValue && (
          <ListContent data={transformData(selectedValue)} />
          // <RowTable data={transformData(selectedValue)} titleWidth={110} />
        )}
      </DetailBox>
    </DetailWrap>
  );
};
export default SummaryBuildingInfo;

const TitleBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const Title = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;

  font-weight: 500;
  font-size: 14px;
`;

const DetailBox = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 8px;
  font-family: 'Spoqa Han Sans Neo';
`;

const DetailWrap = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: fit-content;
  gap: 32px;
  font-family: 'Spoqa Han Sans Neo';
`;

const SelectBoxWrapper = styled.select`
  width: 116px;
  height: 32px;
  border: 1px solid #e8e9ea;
  border-radius: 8px;
  padding: 5px 10px;
  padding-right: 7px;
  display: flex;
  align-items: center;
  justify-content: center;

  color: #616161;
  font-size: 12px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  line-height: 20.3px;
  word-wrap: break-word;
`;
